import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/hot-blood' },
  { label: '排行榜', path: '/category/hot-blood' },
  { label: '最新更新', path: '/category/hot-blood' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-2xl font-heading text-accent-500 font-bold">51</span>
            <span className="text-xl font-heading text-foreground-900 font-bold">漫画</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 hover:text-accent-500 ${
                  location.pathname === item.path ? 'text-accent-500 font-medium' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-40 lg:w-56 h-9 pl-9 pr-3 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-accent-300 transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                onClick={() => setMobileOpen(false)}
                className={`block py-2 text-sm whitespace-nowrap transition-colors hover:text-accent-500 ${
                  location.pathname === item.path ? 'text-accent-500 font-medium' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full h-9 pl-9 pr-3 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-accent-300"
              />
              <i className="ri-search-line absolute text-foreground-400 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}